import React, { useEffect, useRef } from 'react'
import lottie from 'lottie-web';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { FaHome } from 'react-icons/fa';

const NotFound = () => {
    const aniCont = useRef(null);
    
    useEffect(() => {
       lottie.loadAnimation({
           container: aniCont.current,
           renderer: 'svg',
           loop: true,
           autoplay: true,
           animationData: require('../assets/Animations/6719-404-error-glitch.json')
       })
    }, []);

    return ( 
        <>
            <Helmet>
                <meta charset="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="theme-color" content="#000000" />
                <meta
                    name="description"
                    content="Life Long Polytechnic"
                />
                <title>Page Not Found</title>
                {/* <link rel="icon" href={favicon} type="image/ico" sizes="16x16"></link> */}
            </Helmet>
            <div className="grey-background">
                <div className="container">
                    <div className="not-found">
                        <div className="animation" ref={aniCont}></div>
                        <div className="go-home-btn mt2">
                            <Link to="/" class="button is-rounded main-color mt-5 border-none hide-on-med-only hide-on-tiny">
                                <span class="icon">
                                    <FaHome color="white"/>
                                </span>
                                <span className="white-text">Home Page</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
     );
}
 
export default NotFound;